module.exports = __webpack_public_path__ + "static/media/circle-camera.17329bba.svg";